export const fieldsTranslationsUz = {
  'fields-parameters.navbar.services.title': 'Xizmatlar',
  'fields-parameters.title': 'Dala parametrlari',
  'fields-parameters.services.table.title': 'Dalalar',
  'service.field_parameters.column.farmer_name.label': "Fermer xo'jaligi",
  'service.field_parameters.column.field_number.label': 'Dalalar soni',
  'service.field_parameters.column.total_area.label': 'Jami maydon (ga)',
  'service.field_parameters.detail_panel.column.field_name.label': 'Dala nomi',
  'service.field_parameters.detail_panel.column.area.label': 'Maydon (ga)',
  'service.field_parameters.detail_panel.column.service.label': 'Xizmat',
  'service.field_parameters.detail_panel.column.crop.label': 'Ekin',
  'service.field_parameters.detail_panel.column.subscription.label': 'Obuna',
  'service.field_parameters.detail_panel.column.subscription.active.label': 'Faol',
  'service.field_parameters.detail_panel.column.subscription.no_subscription.label': "Obuna yo'q",
  'service.field_parameters.detail_panel.column.service.button.parameter.label': 'Parametrlar',
  'irrigation_field_service_parameters.button.undo.label': "O'zgarishlarni bekor qilish",
  'irrigation_field_service_parameters.button.save.label': "O'zgarishlarni saqlash",
  'irrigation_field_service_parameters.multiple_edition.button.apply.label': "Qo'llash",
  'irrigation_field_service_parameters.multiple_edition.button.clear.label': 'Tozalash',
  'irrigation_field_service_parameters.multiple_edition.title.label': 'Bir nechta dalalarni tahrirlash',
  'irrigation_field_service_parameters.multiple_edition.info.setp1':
    "1- Bir nechta dalalarga qo'llashni xohlagan maydonlarni to'ldiring",
  'irrigation_field_service_parameters.multiple_edition.info.setp2':
    "2- Parametrlarni qo'llamoqchi bo'lgan dalalarni tanlang",
  'irrigation_field_service_parameters.multiple_edition.info.setp3':
    "3- Qo'llash tugmasini bosib tasdiqlang (Diqqat: xatolar paydo bo'lishi mumkin)",
  'irrigation_field_service_parameters.multiple_edition.info.setp4': "4- Yangilashni qo'llash uchun saqlang",
  'irrigation_field_service_parameters.table.Column.farmer_name.label': "Fermer xo'jaligi",
  'irrigation_field_service_parameters.table.Column.field_number.label': 'Dalalar soni',
  'irrigation_field_service_parameters.table.Column.total_area.label': 'Jami maydon (ga)',
  'irrigation_field_service_parameters.table.detail_panel.column.field.label': 'Dala',
  'irrigation_field_service_parameters.table.detail_panel.column.soil.label': 'Tuproq',
  'irrigation_field_service_parameters.table.detail_panel.column.weather_station.label': 'Ob-havo stantsiyasi',
  'irrigation_field_service_parameters.table.detail_panel.column.irrigation_management.label': "Sug'orishni boshqarish",
  'irrigation_field_service_parameters.table.detail_panel.column.irrigation_threshold.label': "Sug'orish chegarasi",
  'irrigation_field_service_parameters.table.detail_panel.column.assolment.label': 'Ekin almashlab ekish',
  'fields-parameters.dialog.error.title': 'Saqlashda xato',
  'fields-parameters.dialog.error.legend': "Ba'zi o'zgarishlaringizda xatolar yuz berdi va saqlanmadi.",
  'fields-parameters.dialog.error.contact':
    "Agar muammo davom etsa, iltimos, bu xatolarni bizning qo'llab-quvvatlash xizmatimizga yuboring: csm@pixagri.fr",
};
